import * as pbiMonthly from '../services/pbiMonthly';

export default {
  namespace: 'pbiMonthly',

  state: {
    embedData: null,
  },

  effects: {
    *getEmbedData({ payload: { values }, callback }, { call, put }) {
      const response = yield call(pbiMonthly.getEmbedData, values);
      yield put({
        type: 'save',
        payload: {
          embedData: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {},
};
